<div
  class="rounded-xl border border-neutral-100 gap-x-3 bg-neutral-50 grid grid-cols-[max-content_auto_max-content] items-center px-4 py-3 w-fit info-card"
>
  <mat-icon [style.alignSelf]="alignIcon" class="icon">
    <ng-content select="[icon]"></ng-content>
  </mat-icon>
  <p class="text-xs text-neutral-800">
    {{ label }}
  </p>
  <button class="text-xs action" (click)="onAction()">
    {{ actionText }}
  </button>
</div>
